import { createFileRoute, redirect } from "@tanstack/react-router";
import { InterceptPage } from "@/features/intercept/page";

export const Route = createFileRoute("/_app/intercept/")({
  // Old links /intercept?tab=settings now live at /settings.
  validateSearch: (search: Record<string, unknown>): { tab?: "settings" } => ({
    tab: search.tab === "settings" ? "settings" : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.tab === "settings") throw redirect({ to: "/settings", replace: true });
  },
  component: InterceptPage,
});
